module.exports = __webpack_public_path__ + "static/media/logo-regione.f44dfa3c.png";